import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useModals from '../Modal/manager/useModal';
import { useNavigate } from 'react-router-dom';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import { checkNumber, isEmpty } from 'utils/Utils';
import TermsModal from '../Modal/TermsModal';
import PrivacyPolicyModal from '../Modal/PrivacyPolicyModal';
import { isMobile } from 'react-device-detect';
import IframeBridge from 'IframeBridge';
import Keypad from '../keypad';
import CardFormErrorModal from '../Modal/CardFormErrorModal';
import ErrorModal from '../Modal/ErrorModal';
import { billkeyRegistRequest } from '../TabCredit/types';
import { useMutation } from 'react-query';
import { BillkeyRegistration } from 'api/Api';
import LoadingIndicator from '../LoadingIndicator';
import ArrowPng from 'app/assets/image/common/arrow.png';
import { useMediaQuery } from 'react-responsive';

interface KeyinFormProps {
  keypadToken: string;
  keyinType: string;
}

const BillkeyRegisterForm = ({ keypadToken, keyinType }: KeyinFormProps) => {
  const refs = {
    firstKeypadRef: useRef<HTMLDivElement>(null),
    secondKeypadRef: useRef<HTMLDivElement>(null),
    expiryDateKeypadRef: useRef<HTMLDivElement>(null),
    lastKeypadRef: useRef<HTMLDivElement>(null),
    tab1Ref: useRef<HTMLDivElement>(null),
  };
  const foucsTerms = useRef<HTMLDivElement>(null);
  const { t, i18n } = useTranslation();
  const { openModal } = useModals();
  const navigate = useNavigate();
  const { paymentState, setPaymentState } = usePaymentState();

  const [loading, setLoading] = useState<boolean>(false);
  const [cardNumber, setCardNumber] = useState<string>('');
  const [familyName, setFamilyName] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [isNoNameError, setNoNameError] = useState<boolean>(false);
  const [identityType, setIdentityType] = useState<'birth' | 'business'>(
    'birth',
  );
  const [isCardNumberError, setCardNumberError] = useState<boolean>(false);
  const [isNoIdentifyNoError, setNoIdentifyNoError] = useState<boolean>(false);
  const [isNoPasswordError, setIsNoPasswordError] = useState<boolean>(false);
  const [isLastCardNumberError, setLastCardNumberError] =
    useState<boolean>(false);
  const [isExpirationDateError, setExpirationDateError] =
    useState<boolean>(false);
  const [agreeCheck, setAgreeCheck] = useState<boolean>(false);
  const [AgreeCheckError, setAgreeCheckError] = useState<boolean>(false);

  const [encryptedFirstCardNumber, setEncryptedFirstCardNumber] = useState({
    data: null,
    hmac: null,
    coordType: 'PIN',
    shuffleType: 'RANDOM',
    encryptionType: 'AES128',
    length: 0,
  });

  const [encryptedSecondCardNumber, setEncryptedSecondCardNumber] = useState({
    data: null,
    hmac: null,
    coordType: 'PIN',
    shuffleType: 'RANDOM',
    encryptionType: 'AES128',
    length: 0,
  });

  const [encodedExpiryDateMonth, setEncodedExpiryDateMonth] = useState({
    data: null,
    hmac: null,
    coordType: 'PIN',
    shuffleType: 'RANDOM',
    encryptionType: 'AES128',
    length: 0,
  });
  const [encodedExpiryDateYear, setEncodedExpiryDateYear] = useState({
    data: null,
    hmac: null,
    coordType: 'PIN',
    shuffleType: 'RANDOM',
    encryptionType: 'AES128',
    length: 0,
  });

  const [encodedIdentityNumber, setEncodedIdentityNumber] = useState({
    data: null,
    hmac: null,
    coordType: 'PIN',
    shuffleType: 'RANDOM',
    encryptionType: 'AES128',
    length: 0,
  });

  const [encodedPassword, setEncodedPassword] = useState({
    data: null,
    hmac: null,
    coordType: 'PIN',
    shuffleType: 'RANDOM',
    encryptionType: 'AES128',
    length: 0,
  });

  const [isEncryptedFirstCardNumberError, setEncryptedFirstCardNumberError] =
    useState<boolean>(false);
  const [isEncryptedSecondCardNumberError, setEncryptedSecondCardNumberError] =
    useState<boolean>(false);
  const [lastCardNumber, setLastCardNumber] = useState<string>('');
  const [open, setOpen] = useState<boolean>(false);
  const isMobileSize = useMediaQuery({ maxWidth: 767 });

  // 2D 결제 실행
  const Registration = useMutation(
    (request: billkeyRegistRequest) => BillkeyRegistration(request),
    {
      onSuccess: data => {
        const returnObj = {
          tid: data.data.tid,
          billKey: data.data.billKey,
          billKeyStatus: data.data.billKeyStatus,
          orderId: data.data.orderId,
          reason: data.data.reason,
        };
        setLoading(false);
        handleReturnObj(returnObj);
      },
      onError: error => {
        setLoading(false);
        navigate('/error');
      },
    },
  );

  const onChangeCardNumber = e => {
    const value = e.target.value;
    if (value.length === 0) {
      setCardNumber('');
      return;
    }
    //숫자 외 입력 못하도록 변경
    const isNumber = checkNumber(value.charAt(value.trim().length - 1));
    if (isNumber) {
      setCardNumber(e.target.value);
    }

    if (value.length === 4) {
      const nextRef = document.querySelectorAll('div.input.firstKeypad')[0]
        .children[1] as HTMLElement;
      if (nextRef) {
        nextRef.focus();
        nextRef.click();
      }
    }
  };

  const focusCardNumber = e => {
    if (refs.tab1Ref.current) {
      refs.tab1Ref.current.scrollTop = 150;
    }
  };

  const onChangeLastCardNumber = useCallback(
    e => {
      const value = e.target.value;
      if (value.length === 0) {
        setLastCardNumber('');
        return;
      }
      //숫자 외 입력 못하도록 변경
      const isNumber = checkNumber(value.charAt(value.trim().length - 1));
      if (isNumber) {
        setLastCardNumber(e.target.value);
      }

      if (value.length === 6) {
        const nextRef = document.querySelectorAll(
          'div.input.expiryDateMonthKeyin',
        )[0].children[1] as HTMLElement;
        if (nextRef) {
          nextRef.focus();
          nextRef.click();
        }
        // if (refs.tab1Ref.current) {
        //   refs.tab1Ref.current.scrollTop = 200;
        // }
      }
    },
    [lastCardNumber],
  );

  const handleTermsOrPrivacy = content => {
    if (content === 'SERVICE') {
      openModal(TermsModal, {
        onSubmit: () => {},
      });
    } else {
      openModal(PrivacyPolicyModal, {
        onSubmit: () => {},
      });
    }
  };

  const openInputError = () => {
    openModal(CardFormErrorModal, {
      error: t('card_input_error'),
      message: t('card_input_error_msg'),
    });
  };

  const clickPay = async e => {
    e.preventDefault();

    // 이름, 성 체크
    if (isEmpty(familyName) || isEmpty(name)) {
      setNoNameError(true);
      openInputError();
      return;
    }
    setNoNameError(false);

    if (cardNumber.length < 4) {
      setCardNumberError(true);
      openInputError();
      return;
    }
    setCardNumberError(false);

    if (encryptedFirstCardNumber.length < 4) {
      setEncryptedFirstCardNumberError(true);
      openInputError();
      return;
    }

    setEncryptedFirstCardNumberError(false);

    if (encryptedSecondCardNumber.length < 4) {
      setEncryptedSecondCardNumberError(true);
      openInputError();
      return;
    }

    setEncryptedSecondCardNumberError(false);

    if (lastCardNumber.length < 3 || lastCardNumber.length > 6) {
      setLastCardNumberError(true);
      openInputError();
      return;
    }

    setLastCardNumberError(false);

    if (encodedExpiryDateMonth.length < 2 || encodedExpiryDateYear.length < 2) {
      setExpirationDateError(true);
      openInputError();
      return;
    }

    setExpirationDateError(false);

    if (keyinType.includes('I')) {
      if (encodedIdentityNumber.length < 6) {
        setNoIdentifyNoError(true);
        openModal(ErrorModal, {
          message: t('error_identityNo_check'),
        });
        return;
      }
    }
    if (keyinType.includes('P')) {
      if (encodedPassword.length < 1) {
        setIsNoPasswordError(true);
        openModal(ErrorModal, {
          message: t('error_password_check'),
        });
        return;
      }
    }

    if (!agreeCheck) {
      setAgreeCheckError(true);
      openModal(ErrorModal, {
        message: t('error_agree_check'),
      });
      foucsTerms.current?.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    const billkeyRequest: billkeyRegistRequest = {
      cardNumber: {
        firstCardNumber: cardNumber,
        encSecondCardNumber: encryptedFirstCardNumber,
        encThirdCardNumber: encryptedSecondCardNumber,
        lastCardNumber: lastCardNumber,
      },
      cardMonth: encodedExpiryDateMonth,
      cardYear: encodedExpiryDateYear,
      keypadToken: keypadToken,
      ...(keyinType.includes('P') && { cardPassword: encodedPassword }),
      ...(keyinType.includes('I') && { identityNumber: encodedIdentityNumber }),
      cardHolder: `${familyName} ${name}`,
      tid: paymentState.tid,
      orderId: paymentState.orderId,
      webhookUrl: paymentState.webhookUrl,
    };
    setLoading(true);

    await Registration.mutate(billkeyRequest);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Enter 키의 기본 동작을 중지시킴
    }
  };

  const handleReturnObj = obj => {
    if (isMobile) {
      const url = new URL(paymentState.returnUrl);
      const params = new URLSearchParams(url.search);
      params.set('tid', obj.tid);
      params.set('billKey', obj.billKey);
      params.set('billKeyStatus', obj.billKeyStatus);
      params.set('reason', obj.reason);
      params.set('orderId', obj.orderId);

      window.location.href = url + '?' + params;
    } else {
      const returnObj = {
        ...obj,
        returnUrl: paymentState.returnUrl,
      };
      window.sessionStorage.removeItem('auth');
      window.sessionStorage.removeItem('mid');
      window.sessionStorage.removeItem('clientKey');
      IframeBridge.sendViewOff(returnObj);
    }
  };

  const handleAllClose = e => {
    e.preventDefault();

    const returnObject = {
      resultStatus: 'FAILED',
      resultCode: 'FAIL',
      resultMessage: 'Unprocessed payment.',
      tid: paymentState.tid,
      returnUrl: paymentState.returnUrl,
    };

    if (isMobile) {
      const url = new URL(paymentState.returnUrl);
      const params = new URLSearchParams(url.search);

      params.set('resultStatus', 'FAILED');
      params.set(
        'resultCode',
        paymentState.resultCode ? paymentState.resultCode : '',
      );
      params.set(
        'resultMessage',
        paymentState.resultMessage ? paymentState.resultMessage : '',
      );
      params.set('tid', paymentState.tid);
      params.set('orderId', paymentState.orderId);
      window.location.href = url + '?' + params;
    } else {
      window.sessionStorage.removeItem('auth');
      window.sessionStorage.removeItem('mid');
      window.sessionStorage.removeItem('clientKey');
      IframeBridge.sendViewOff(returnObject);
    }
  };

  useEffect(() => {
    setEncodedIdentityNumber({
      data: null,
      hmac: null,
      coordType: 'PIN',
      shuffleType: 'RANDOM',
      encryptionType: 'AES128',
      length: 0,
    });
  }, [identityType]);

  return (
    <>
      {loading ? (
        <div
          style={{
            display: 'flex',
            height: isMobileSize ? 'calc(100% - 80px)' : 'calc(100% - 130px)',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <LoadingIndicator />
        </div>
      ) : (
        <>
          <div className="b-section">
            <div className="tab">
              <div
                ref={refs.tab1Ref}
                id="tab-1"
                className="tab-on current"
                style={
                  isMobileSize
                    ? { height: 'calc((var(--vh, 1vh) * 100) - 300px)' }
                    : { height: 370 }
                }
              >
                <div className="form first">
                  <div className="title">{t('card_holder_title')}</div>
                  <ul className="depth-2">
                    <li>
                      <div className="sub-title">
                        {t('first_name')}
                        <span className="redstar">*</span>
                      </div>
                      <div className={isNoNameError ? 'input error' : 'input'}>
                        <input
                          name="text"
                          type="text"
                          onChange={e => {
                            setName(e.target.value);
                          }}
                          value={name}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="sub-title">
                        {t('last_name')}
                        <span className="redstar">*</span>
                      </div>
                      <div className={isNoNameError ? 'input error' : 'input'}>
                        <input
                          name="text"
                          type="text"
                          onChange={e => {
                            setFamilyName(e.target.value);
                          }}
                          value={familyName}
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="form">
                  <ul className="depth-1">
                    <li
                      className="input"
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        marginBottom: 10,
                      }}
                    ></li>
                    <div
                      style={{
                        fontSize: '14px',
                        color: '#8a9db4',
                        marginBottom: '5px',
                      }}
                      className="sub-title"
                    >
                      {t('card_number')}
                      <span className="redstar">*</span>
                    </div>
                    <li style={{ display: 'flex', flexWrap: 'wrap' }}>
                      <div
                        className={isCardNumberError ? 'input error' : 'input'}
                        style={{ width: '22%', float: 'left', order: 1 }}
                      >
                        <a></a>
                        <input
                          id="card"
                          name="text"
                          type="text"
                          maxLength={4}
                          placeholder={'0000'}
                          onChange={onChangeCardNumber}
                          onFocus={focusCardNumber}
                          value={cardNumber}
                          //   ref={refs.cardNumberRef}
                        />
                      </div>
                      <Keypad
                        identifier={'firstKeypad'}
                        // cardNumber={cardNumber}
                        setStateFunction={setEncryptedFirstCardNumber}
                        isError={isEncryptedFirstCardNumberError}
                        setError={setEncryptedFirstCardNumberError}
                        textLength="4"
                        placeholderText="0000"
                        css={{
                          width: '22%',
                          float: 'left',
                          marginLeft: '4%',
                          order: '2',
                        }}
                        keypadToken={keypadToken}
                      />
                      <Keypad
                        identifier={'secondKeypad'}
                        setStateFunction={setEncryptedSecondCardNumber}
                        isError={isEncryptedSecondCardNumberError}
                        setError={setEncryptedSecondCardNumberError}
                        textLength="4"
                        placeholderText="0000"
                        css={{
                          width: '22%',
                          float: 'left',
                          marginLeft: '4%',
                          order: '3',
                        }}
                        keypadToken={keypadToken}
                      />
                      <div
                        className={
                          isLastCardNumberError
                            ? 'input lastCardNumber error'
                            : 'input lastCardNumber'
                        }
                        style={{
                          width: '22%',
                          float: 'left',
                          marginLeft: '4%',
                          order: 4,
                        }}
                      >
                        <a></a>
                        <input
                          id="lastCardNumber"
                          name="text"
                          type="text"
                          maxLength={6}
                          minLength={3}
                          placeholder={'000000'}
                          onChange={onChangeLastCardNumber}
                          value={lastCardNumber}
                          //   ref={refs.lastKeypadRef}
                        />
                      </div>
                      {(isCardNumberError || isLastCardNumberError) && (
                        <div style={{ order: 5 }} className="error-text">
                          {t('invalid_card_error_text')}
                        </div>
                      )}
                    </li>
                  </ul>
                  <ul className="depth-2">
                    <li>
                      <div className="sub-title">
                        {t('expiration_date')}
                        <span className="redstar">*</span>
                      </div>
                      <div style={{ display: 'flex' }}>
                        <Keypad
                          identifier={'expiryDateMonthKeyin'}
                          setStateFunction={setEncodedExpiryDateMonth}
                          placeholderText="MM"
                          textLength="2"
                          isError={isExpirationDateError}
                          setError={setExpirationDateError}
                          css={{ width: '45%' }}
                          // ref={expiryDateKey}
                          keypadToken={keypadToken}
                        />
                        <Keypad
                          identifier={'expiryDateYearKeyin'}
                          setStateFunction={setEncodedExpiryDateYear}
                          placeholderText="YY"
                          textLength="2"
                          isError={isExpirationDateError}
                          setError={setExpirationDateError}
                          css={{ width: '45%', marginLeft: '10%' }}
                          // ref={expiryDateKey}
                          keypadToken={keypadToken}
                        />
                      </div>
                    </li>
                    <li></li>
                  </ul>
                  {keyinType.includes('I') && (
                    <ul className="depth-2">
                      <li style={{ width: '100%' }}>
                        <div className="sub-title">
                          {t('keyinIdentity')}
                          <span className="redstar">*</span>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            gap: 5,
                            padding: '5px 0px',
                          }}
                        >
                          <input
                            type="radio"
                            name="cardSelect"
                            value={'birth'}
                            checked={identityType === 'birth'}
                            onChange={e => setIdentityType('birth')}
                          />
                          {t('birthday')}
                          <input
                            type="radio"
                            name="cardSelect"
                            value={'business'}
                            checked={identityType === 'business'}
                            onChange={e => setIdentityType('business')}
                          />
                          {t('businessNumber')}
                        </div>
                      </li>
                      <li style={{ width: '50%' }}>
                        <div
                          className={
                            isNoIdentifyNoError ? 'input error' : 'input'
                          }
                        >
                          <Keypad
                            identifier={'identityNumber'}
                            type={identityType}
                            setStateFunction={setEncodedIdentityNumber}
                            placeholderText={''}
                            textLength={identityType === 'birth' ? '6' : '10'}
                            isError={isNoIdentifyNoError}
                            setError={setNoIdentifyNoError}
                            css={{ width: '100%' }}
                            keypadToken={keypadToken}
                          />
                        </div>
                      </li>
                    </ul>
                  )}
                  {keyinType.includes('P') && (
                    <ul className="depth-2">
                      <li>
                        <div className="sub-title">
                          {t('password')}
                          <span className="redstar">*</span>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                            height: '100%',
                            gap: 5,
                            alignItems: 'center',
                          }}
                        >
                          <Keypad
                            identifier={'keypadPassword'}
                            setStateFunction={setEncodedPassword}
                            placeholderText="**"
                            textLength="2"
                            isError={isNoPasswordError}
                            setError={setIsNoPasswordError}
                            css={{ width: '25%' }}
                            // ref={expiryDateKey}
                            keypadToken={keypadToken}
                          />
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              height: '100%',
                            }}
                          >
                            {'**'}
                          </div>
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="text" style={{ fontSize: 14, marginLeft: 10 }}>
              ※{t('billkeyInfo')}
            </div>
            <div className="agreeFloatBox">
              <div className="label" ref={foucsTerms}>
                <div className="check">
                  <input
                    type="checkbox"
                    id={AgreeCheckError ? 'checkbox error' : 'checkbox'}
                    name="agree"
                    checked={agreeCheck}
                    onChange={e => {
                      setAgreeCheck(e.target.checked);
                    }}
                  />

                  <label
                    htmlFor={AgreeCheckError ? 'checkbox error' : 'checkbox'}
                  ></label>
                </div>
                <div className="columnBox">
                  <div className="text">
                    <div
                      onClick={() => setAgreeCheck(!agreeCheck)}
                      style={{ cursor: 'pointer' }}
                    >
                      {t('start_agree_terms')}
                      {t('terms_and_conditions')}
                      {t('and_the')}
                      {t('privacy_policy')}
                      {t('end_agree_terms')}
                    </div>
                    <img
                      className={`arrow ${open ? 'open' : ''}`}
                      src={ArrowPng}
                      alt=""
                      onClick={() => setOpen(!open)}
                    />
                  </div>
                  <div className={`text toggleRow ${open ? 'open' : ''}`}>
                    <p className="dot">●</p>
                    <span
                      className="link"
                      onClick={() => handleTermsOrPrivacy('SERVICE')}
                    >
                      {t('terms_and_conditions')}
                    </span>
                  </div>
                  <div className={`text toggleRow ${open ? 'open' : ''}`}>
                    <p className="dot">●</p>
                    <span
                      className="link"
                      onClick={() => handleTermsOrPrivacy('PRIVACY')}
                    >
                      {t('privacy_policy')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="c-section">
              <div className="box">
                <button className="all-close" onClick={handleAllClose}>
                  {t('close')}
                </button>
                <button
                  className="orange"
                  onClick={clickPay}
                  onKeyDown={e => handleKeyDown(e)}
                >
                  {t('pay_now')}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default BillkeyRegisterForm;
